import Path from "./Path";
export class Node {
    constructor(path, type) {
        this.path = path;
        this.type = type;
        this.args = {};
        this.toString = () => {
            return JSON.stringify({
                path: this.path.path,
                type: this.type,
                exeCmd: this.exeCmd,
                iconPath: this.iconPath,
            });
        };
        this.id = type + path.path;
        this.exeCmd = this._setDefaultCmd(path, type);
        this.iconPath = this._setDefaultIcon(type);
    }
    static fromString(str) {
        const parsed = JSON.parse(str);
        return new Node(new Path(parsed.path), parsed.type)
            .setCmd(parsed.exeCmd)
            .setIconPath(parsed.iconPath);
    }
    setCmd(cmd, args) {
        this.exeCmd = cmd;
        if (args) {
            this.setArgs(args);
        }
        ;
        return this;
    }
    setArgs(args) {
        this.args = Object.assign({}, args);
        return this;
    }
    setIconPath(path) {
        this.iconPath = path;
        return this;
    }
    _setDefaultIcon(type) {
        let retval = "/imgs/icon-default.svg";
        switch (type) {
            case "text":
            case "dir":
            case "terminal":
            case "logger":
            case "broom":
            case "postman":
            case "atelier":
            case "notepad":
            case "bakery":
            case "savebread":
            case "styler":
            case "loadbread":
            case "finder":
            case "settings":
                retval = `/imgs/${type}.svg`;
                break;
            case "about":
            case "hub":
                retval = "/imgs/jamos256.png";
                break;
            case "resetbread":
                retval = "/imgs/loading.svg";
                break;
            case "image":
            default:
                break;
        }
        return retval;
    }
    _setDefaultCmd(path, type) {
        let retval = type;
        switch (type) {
            case "dir":
                retval = `finder ${path.path}`;
                break;
            case "text":
                retval = `notepad ${path.path}`;
                break;
            case "image":
                retval = `viewer ${path.path}`;
                break;
        }
        return retval;
    }
    isSame(rhs) {
        return this.id === rhs.id;
    }
    get parent() {
        return this.path.parent;
    }
}
export function filesInDirectory(dir) {
    const dirCount = dir.dirs.length;
    const fileCount = dir.files.length;
    return {
        totalDirs: dirCount +
            dir.dirs.reduce((prev, cur) => {
                return prev + filesInDirectory(cur).totalDirs;
            }, 0),
        totalFiles: fileCount +
            dir.dirs.reduce((prev, cur) => {
                return prev + filesInDirectory(cur).totalFiles;
            }, 0),
        curDirs: dirCount,
        curFiles: fileCount,
    };
}
export function FileToString(file) {
    return JSON.stringify({
        node: file.node.toString(),
        data: JSON.stringify(file.data),
    });
}
export function StringToFile(str) {
    const parsed = JSON.parse(str);
    const file = {
        node: Node.fromString(parsed.node),
        data: parsed.data ? JSON.parse(parsed.data) : {},
    };
    return file;
}
